module.exports = __webpack_public_path__ + "static/img/axures-small.a877fd4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Cattle/axures-small.png
// module id = Bz7J
// module chunks = 0